import Interceptor from "./Interceptor";

// ==================== Organizations ====================

export const listOrganizations = async () => {
  const response = await Interceptor.get("/orgs");
  return response.data;
};

export const createOrganization = async (payload) => {
  const response = await Interceptor.post("/orgs", payload);
  return response.data;
};

export const getOrganization = async (orgId) => {
  const response = await Interceptor.get(`/orgs/${orgId}`);
  return response.data;
};

export const updateOrganization = async (orgId, payload) => {
  const response = await Interceptor.put(`/orgs/${orgId}`, payload);
  return response.data;
};

export const deleteOrganization = async (orgId) => {
  const response = await Interceptor.delete(`/orgs/${orgId}`);
  return response.data;
};

// ==================== Members ====================

export const listMembers = async (orgId) => {
  const response = await Interceptor.get(`/orgs/${orgId}/members`);
  return response.data;
};

export const updateMemberRole = async (orgId, memberId, role) => {
  const response = await Interceptor.put(`/orgs/${orgId}/members/${memberId}`, {
    role,
  });
  return response.data;
};

export const removeMember = async (orgId, memberId) => {
  const response = await Interceptor.delete(
    `/orgs/${orgId}/members/${memberId}`,
  );
  return response.data;
};

export const transferOwnership = async (orgId, memberId) => {
  const response = await Interceptor.post(`/orgs/${orgId}/transfer`, {
    memberId,
  });
  return response.data;
};

// ==================== Invitations ====================

export const createInvitation = async (orgId, payload) => {
  const response = await Interceptor.post(
    `/orgs/${orgId}/invitations`,
    payload,
  );
  return response.data;
};

export const listInvitations = async (orgId) => {
  const response = await Interceptor.get(`/orgs/${orgId}/invitations`);
  return response.data;
};

export const revokeInvitation = async (orgId, invitationId) => {
  const response = await Interceptor.delete(
    `/orgs/${orgId}/invitations/${invitationId}`,
  );
  return response.data;
};

export const getInvitationByToken = async (token) => {
  const response = await Interceptor.get(`/invitations/${token}`);
  return response.data;
};

export const acceptInvitation = async (token) => {
  const response = await Interceptor.post(`/invitations/${token}/accept`);
  return response.data;
};

export const getMyPendingInvitations = async () => {
  const response = await Interceptor.get(`/invitations`);
  return response.data;
};
